<template>
  <div class="campaign-edit-content medium-8 columns divider-vertical">
    <slot name="groups"></slot>
    <slot name="selectedViewToggle"></slot>
    <div class="campaign-content">
      <toggle-section-slide
          key="sms"
          :shouldOpen="smsSend"
          toggleText="text content"
          toggleTextClasses="text-link"
          :wrapperClasses="smsWrapperClasses"
          @onToggleTextClick="$emit('toggleSend', 'sms')">

        <div slot="mainContent">
          <message
            :campaign="campaign"
            :active-message="true"
            :campaignSendTime="campaignSendTime"
            :smsSend="smsSend"
            @update="updateCampaign">
          </message>

          <template v-if="!classicCampaignsEnabled">
            <div class="data-description" style="margin-top:30px;margin-bottom:20px">
              <b>select a notification message</b>

              <div>
                choose a message to send your members as a text, and we will include a secure link to the stashboard you've created above
              </div>
            </div>

            <text-notification-picker
              :selected="selectedNotificationTemplate"
              :templates="getCampaignNotificationTemplates"
              v-on:update:selected="updatedSelectedNotification"
              style="margin-bottom:10px"
            />
          </template>

          <notification-images v-if="haveClassicCampaignDisabledAndNotificationMmsEnabled"
                               :custom-notification-images="customNotificationImages"
                               :selected-notification-image="campaign.template_image"
                               :suggested-notification-images="suggestedNotificationImages"
                               @updateSelectedNotificationImage="updateSelectedNotificationImage" />

          <div class="data-description">
            <b>credit summary</b>

            <div>
              characters {{ characterCount }}, credits {{ totalCredits }}
            </div>
          </div>
        </div>

        <!--<toggle-section-slide
            v-if="!merchantCountryIsCanada"
            slot="extraContent"
            key="backup"
            :shouldOpen="showBackup"
            toggleText="optimize campaign deliverability"
            toggleTextClasses="backup-campaign__toggle-text"
            wrapperClasses="backup-campaign"
            @onToggleTextClick="$emit('setShowBackupStatus', !showBackup)">
          <campaign-backup-edit
              slot="mainContent"
              :parentId="campaignId"
              :showBackup="showBackup"
              :shouldCancelBackup="shouldCancelBackup"
              :smsSend="smsSend">
          </campaign-backup-edit>
        </toggle-section-slide>-->
      </toggle-section-slide>

      <toggle-section-slide
        key="email"
        :shouldOpen="emailSend"
        toggleText="email content"
        toggleTextClasses="email-link"
        :wrapperClasses="emailWrapperClasses"
        @onToggleTextClick="onToggleEmailClick"
        >
        <template #mainContent>
          <div class="email-preview">
            <input
              type="text"
              :class="{error: !emailSubject}"
              name="email-subject"
              v-model="emailSubject"
              placeholder="email subject"
              @input="validateEmailSubjectAndUpdateCampaign"
            />
            <template v-if="selectedEmailTemplate">
              <div v-if="selectedEmailTemplate.preview_image" class="image-preview">
                <img :src="selectedEmailTemplate.preview_image" alt="campaign-email" />
              </div>
              <div v-else>
                <span class="loading-text text-20">generating email preview</span>
                <span class="loading-text text-10">(if time exceeds more than 1min. please refresh the page)</span>
              </div>

              <div class="email-action">
                <a class="button clear edit-button" @click="selectedEmailModal = 'email-creation'">edit</a>
                <a class="button clear delete-button" @click="deleteEmailTemplate(selectedEmailTemplate.id)">delete</a>
              </div>
            </template>
            <div v-else class="text-white text-xl bg-red p-1 rounded-md">email template not found</div>
          </div>
        </template>
      </toggle-section-slide>
    </div>

    <email-template-selection-modal
      v-if="selectedEmailModal === 'email-template-selection'"
      :email="email"
      @closeEmailTemplateSelectionModal="cancelModalWithoutChanges"
      @openEmailCreationModalAndSetTemplate="openEmailCreationModalAndSetTemplate"
      @refreshTemplateList="getEmailTemplates"
    />

    <email-creation-modal
      v-if="selectedEmailModal === 'email-creation'"
      :email="email"
      :campaign="campaign"
      :email-subject="emailSubject"
      @closeEmailCreationModal="cancelModalWithoutChanges"
      @toggleSend="toggleEmailSend"
      @updateEmailSubject="validateEmailSubjectAndUpdateCampaign"
      :selected-email-template.sync="selectedEmailTemplate"
    />
    <slot name="scheduler"></slot>
  </div>
</template>


<script>
  import CampaignBackupEdit from './CampaignBackupEdit'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Message from '../../components/Message/index'
  import NotificationImages from '../../components/NotificationImages/notification-images.vue'
  import ToggleSectionSlide from '../../components/shared/ToggleSectionSlide'
  import TextNotificationPicker from "../TextNotificationPicker";
  import {currentMerchantAPI} from "../../services/api/currentMerchant.js";
  import {campaignAPI} from "../../services/api/campaignAPI.js";
  import {beeAPI} from "../../services/api/beeAPI.js";
  import EmailTemplateSelectionModal from "../Campaigns2/email-modal/email-template-selection.vue";
  import EmailCreationModal from "../Campaigns2/email-modal/email-creation.vue";

  export default {
    props: {
      campaign: Object,
      backupCampaignIds: Array,
      campaignId: [Number, String],
      campaignSendTime: String,
      emailSend: Boolean,
      sendAtLocal: String,
      selectedView: String,
      sendBackup: Boolean,
      shouldCancelBackup: Boolean,
      showBackup: Boolean,
      smsSend: Boolean,
    },

    name: 'CampaignCreationContent',

    components: {
      CampaignBackupEdit,
      EmailCreationModal,
      EmailTemplateSelectionModal,
      Message,
      NotificationImages,
      ToggleSectionSlide,
      TextNotificationPicker
    },

    data() {
      return {
        backupCampaignId: null,
        customNotificationImages: null,
        email: null,
        emailSubject: null,
        error: null,
        selectedEmailModal: null,
        selectedEmailTemplate: null,
        suggestedNotificationImages: null
      }
    },

    methods: {
      async deleteEmailTemplate(templateId){
        const resp = await beeAPI.deleteEmailTemplate(templateId);
        if(resp.status !== 200){
          this.$emit("setApiErrors");
        }
        this.$emit("updateCampaign", { email_send: false, email_subject: null });
        this.selectedEmailTemplate = null;
        this.emailSubject = null;
      },

      async getEmailTemplates(){
        const data = await campaignAPI.getEmailTemplates(this.campaign.id);
        return data;
      },

      async setNotificationImagesForCurrentMerchant() {
        if(this.haveClassicCampaignDisabledAndNotificationMmsEnabled) {
          const { shared_images, merchant_images } = await currentMerchantAPI.getNotificationImages("campaign")
          this.customNotificationImages = merchant_images
          this.suggestedNotificationImages = shared_images
        }
      },

      initBackupMessageModule() {
        this.backupCampaignId = this.backupCampaignIds ? this.backupCampaignIds[0] : null
        this.UPDATE_BOOLEAN_STATUS({stateKey: 'isBackup', status: true})
        if (this.backupCampaignId) {
          this.UPDATE_MESSAGE_ID_TYPE({messageId: this.backupCampaignId, messageType: 'Campaign'})
          this.$emit('setShowBackupStatus', true)
        }
      },

      async onToggleEmailClick(){
        const templates = await this.getEmailTemplates(this.campaign.id);
        this.email = templates;
        if(this.emailSend) {
          // Closing the slider -> remove interaction error
          this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {}})
        }

        if(!this.emailSend && !this.emailSubject) {
          // Opening the slider without subject filled out -> set interaction error
          this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {subject: true}})
        }

        if(!templates?.specific_campaign_template){
          // Opening the slider without an attached template -> toggle selection modal
          this.selectedEmailTemplate = templates.specific_campaign_template;
          this.selectedEmailModal = "email-template-selection";
        } else {
          // Opening or closing slider with an attached template -> toggle emailSend
          this.$emit("toggleSend","email");
        }
      },

      openEmailCreationModalAndSetTemplate(template) {
        this.selectedEmailTemplate = template;
        this.selectedEmailModal = "email-creation";
      },

      toggleEmailSend(){
        return (!this.emailSend) ? this.$emit("toggleSend","email") : null;
      },

      updateCampaign(dataToUpdate) {
        this.$emit('updateCampaign', dataToUpdate)
      },

      updatedSelectedNotification(newTemplate) {
        this.updateCampaign({
          template_id: newTemplate.id
        });
      },

      updateSelectedNotificationImage(image) {
        this.updateCampaign({
          template_image_id: (image) ? image.id : null
        });
      },

      setEmailSubjectError(){
        if(!this.emailSubject) {
          this.error = 'email subject cannot be empty';
          return true;
        }else if(this.emailSubject.length > 255) {
          this.error = 'email subject cannot be over 255 characters';
          return true;
        }
        return false
      },

      validateEmailSubjectAndUpdateCampaign(_event, subjectString = null) {
        if (subjectString != null) {this.emailSubject = subjectString};
        if(this.setEmailSubjectError()) {
          this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {subject: true}})
          // Allow user to delete email subject
          if(!this.emailSubject) {
            this.updateCampaign({ email_subject: this.emailSubject })
          }
        }else{
          this.updateCampaign({ email_subject: this.emailSubject })
          this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {}})
        }
      },

      cancelModalWithoutChanges() {
        this.selectedEmailModal = null
        this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {}})
      },

      ...mapActions({
        UPDATE_MESSAGE_ID_TYPE: 'backup/UPDATE_MESSAGE_ID_TYPE',
        UPDATE_BOOLEAN_STATUS: 'backup/UPDATE_BOOLEAN_STATUS',
        UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT'
      })
    },

    async created() {
      this.initBackupMessageModule()
      this.setNotificationImagesForCurrentMerchant()

      const templates = await this.getEmailTemplates();
      if(templates.specific_campaign_template) {
        this.selectedEmailTemplate = templates.specific_campaign_template;
      }
      const emailSubject = this.campaign.email_subject;
      if(emailSubject) {
        this.emailSubject = emailSubject;
      }
      if(!emailSubject && this.emailSend){
         this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {subject: true}})
      }
    },

    computed: {
      emailWrapperClasses: function () {
        const slideStatus = this.selectedView === 'email' ? 'slide-in' : 'slide-out'
        return 'email-section ' + slideStatus
      },

      haveClassicCampaignDisabledAndNotificationMmsEnabled(){
        return !this.classicCampaignsEnabled && this.hasNotificationMmsMetaEnabled
      },

      smsWrapperClasses: function () {
        const baseClasses = 'message-section scope-wrapper ',
          slideStatus = this.selectedView === 'sms' ? 'slide-in' : 'slide-out',
          highlightClass = this.showBlacklistModal ? ' js-has-word-highlight' : ''
        return baseClasses + slideStatus + highlightClass
      },

      selectedNotificationTemplate() {
        return this.$store.getters.selectedNotificationTemplateFor('message');
      },

      ...mapState({
        showBlacklistModal: state => state.message.showBlacklistModal
      }),
      ...mapGetters(['merchantCountryIsCanada', 'classicCampaignsEnabled', 'getCampaignNotificationTemplates', 'hasNotificationMmsMetaEnabled']),

      ...mapState('message', ['characterCount']),
      ...mapGetters('message', ['totalCredits']),
    }
  }
</script>

<style scoped>
.email-preview .error {
  border: 1px solid #f91253;
}

.email-preview {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
}

.email-preview .button.clear {
  background-color: transparent;
  color: #128ff9;
  font-size: 16px;
}

.email-preview .email-action {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

.email-preview .edit-button {
  font-family: "AileronLight";
  font-weight: bolder;
}

.email-preview .delete-button {
  font-family: "AileronLight";
}

.email-preview >>> .sb-loading-icon {
  width: 200px;
}

.email-preview .loading-text {
  color: #4a4a4a;
  display: block;
  text-align: center;
  width: 150px;
}

.email-preview .text-20 {
  font-size: 20px;
}

.email-preview .text-10 {
  font-size: 10px;
}
</style>
